import type { QuoteOptions } from 'paintscout'
import type { WorkOrderSectionFilter } from './WorkOrderNavBarNext'

/**
 * The Work Order's All / Areas / Surfaces filter, stored in the same two quote options the legacy
 * work order's per-table show/hide toggles use (`showWorkOrderAreas`, `showWorkOrderSubstrates`), so
 * the customer's Work Order link shows what the editor shows and both editors agree (ENG-2242).
 * Both off has no pill of its own and reads as All.
 */
export function getWorkOrderSectionFilter(
  quoteOptions: Pick<QuoteOptions, 'showWorkOrderAreas' | 'showWorkOrderSubstrates'>
): WorkOrderSectionFilter {
  const { showWorkOrderAreas, showWorkOrderSubstrates } = quoteOptions
  if (showWorkOrderAreas && !showWorkOrderSubstrates) return 'area'
  if (showWorkOrderSubstrates && !showWorkOrderAreas) return 'substrate'
  return 'all'
}

export function getWorkOrderSectionOptions(
  filter: WorkOrderSectionFilter
): Pick<QuoteOptions, 'showWorkOrderAreas' | 'showWorkOrderSubstrates'> {
  return {
    showWorkOrderAreas: filter !== 'substrate',
    showWorkOrderSubstrates: filter !== 'area'
  }
}
